import { Transition } from '../transition/Transition';

export const forgotPasswordPageTransition = new Transition();
// export const invalidRolePageTransition = new Transition();
export const resetPasswordPageTransition = new Transition();
export const signInPageTransition = new Transition();
export const signUpPageTransition = new Transition();
// export const silentSignInPageTransition = new Transition();
export const updateProfilePageTransition = new Transition();
export const verifyEmailPageTransition = new Transition();
